// add here for more access page by role.

export const initialAbility = {
    0: [
        // role id 0
        {
            action: "read",
            subject: "Auth"
        }
    ],
    1: [
        // role id 1
        {
            action: "read",
            subject: "Auth"
        },
        {
            action: "read",
            subject: "Admin"
        }
    ],
    2: [
        // role id 1
        {
            action: "read",
            subject: "Auth"
        },
        {
            action: "read",
            subject: "Admin"
        },
        {
            action: "read",
            subject: "Home"
        },
        {
            action: "write",
            subject: "Home"
        },
        {
            action: "write",
            subject: "User"
        },
        {
            action: "read",
            subject: "User"
        },
        {
            action: "write",
            subject: "Pendidikan"
        },
        {
            action: "read",
            subject: "Pendidikan"
        },
        {
            action: "write",
            subject: "Member"
        },
        {
            action: "read",
            subject: "Member"
        },
        {
            action: "write",
            subject: "SuperMember"
        },
        {
            action: "read",
            subject: "SuperMember"
        },
        {
            action: "read",
            subject: "MemberFakultas"
        },
        {
            action: "read",
            subject: "MemberJurusan"
        },
        {
            action: "read",
            subject: "MemberDocument"
        },
        {
            action: "read",
            subject: "MemberEmail"
        },
        {
            action: "write",
            subject: "MemberVerify"
        },
        {
            action: "write",
            subject: "PendidikanVerify"
        },
        {
            action: "read",
            subject: "FetchMember"
        },
        {
            action: "read",
            subject: "Mentorship"
        },
        {
            action: "write",
            subject: "Mentorship"
        },
        {
            action: "read",
            subject: "ListStatusAdmin"
        },
        {
            action: "read",
            subject: "ListStatusAdminFakultas"
        },
        {
            action: "read",
            subject: "ListMemberAdmin"
        },
        {
            action: "read",
            subject: "ListMemberAdminFakultas"
        }
    ],
    /* custom by email */
    byEmail: {
        allowEmails: ["panitia@gmail.com", "pemila@uiconnect.id", "sc-pemila@uiconnect.id"],
        data: [
            {
                action: "read",
                subject: "Auth"
            },
            {
                action: "read",
                subject: "Admin"
            },
            {
                action: "read",
                subject: "Home"
            },
            {
                action: "write",
                subject: "Home"
            },
            {
                action: "write",
                subject: "Member"
            },
            {
                action: "read",
                subject: "Member"
            },
            {
                action: "read",
                subject: "MemberFakultas"
            },
            {
                action: "read",
                subject: "MemberJurusan"
            },
            {
                action: "read",
                subject: "MemberDocument"
            },
            {
                action: "read",
                subject: "MemberEmail"
            },
            {
                action: "read",
                subject: "FetchMember"
            },
            {
                action: "read",
                subject: "ListStatusAdmin"
            },
            {
                action: "read",
                subject: "ListStatusAdminFakultas"
            },
            {
                action: "read",
                subject: "ListMemberAdmin"
            },
            {
                action: "read",
                subject: "ListMemberAdminFakultas"
            },
        ]
    },
    7: [
        // role id 1
        {
            action: "read",
            subject: "Auth"
        },
        {
            action: "read",
            subject: "Admin"
        },
        {
            action: "read",
            subject: "Home"
        },
        {
            action: "write",
            subject: "Member-Admin-Fakultas"
        },
        {
            action: "read",
            subject: "Member-Admin-Fakultas"
        },
        {
            action: "read",
            subject: "FetchMemberByFaculty"
        },
        {
            action: "read",
            subject: "ListStatusAdminFakultas"
        },
        {
            action: "read",
            subject: "ListMemberAdminFakultas"
        },
        {
            action: "read",
            subject: "AdminFakultas"
        },
        {
            action: "write",
            subject: "AdminFakultas"
        }
    ]
};

export const _ = undefined;
